import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { useAddNotification } from 'hooks/useAddNotification'
import { type Campaign, campaignFromServer, campaignToServer } from 'models/campaign-model'
import { get, patch, put } from 'utils/http'
import { safeNumberFromString } from 'utils/strings'

// Campaign detail; forces details.id to the route id (as the old transformResult did).
const useCampaign = (id: any) =>
  useQuery({
    queryKey: ['campaign', id],
    queryFn: async (): Promise<Campaign> => {
      const body: any = await get(`/management/campaigns/${id}/`)
      return campaignFromServer({ ...body, details: { ...body.details, id } })
    },
    enabled: !!id,
  })

export const useUpdateCampaign = () => {
  const queryClient = useQueryClient()
  const addNotification = useAddNotification()
  return useMutation({
    mutationFn: ({ id, values }: any) =>
      put(`/management/campaigns/${id}`, { ...campaignToServer(values), id: safeNumberFromString(id) }),
    onSuccess: (_d, { id }: any) => queryClient.invalidateQueries({ queryKey: ['campaign', id] }),
    onError: () => addNotification('Campaign data update error', 'error'),
  })
}

export const useAssignUser = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ campaignId, assigneeId }: any) =>
      patch(`/management/campaigns/${campaignId}/assignee`, { adops_id: assigneeId }),
    onSuccess: (_d, { campaignId }: any) => queryClient.invalidateQueries({ queryKey: ['campaign', campaignId] }),
  })
}

export default useCampaign
